// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vvKr","toggleWrap":"styles_toggleWrap__26suL","content":"styles_content__39FpH","selectAreaCode":"styles_selectAreaCode__uShjD"};